import './RecordParent.scss';
import { ArrowLeftOutlined } from '@ant-design/icons';
import React from 'react';
import { When } from 'react-if';

export interface SonarRecordParentProps {
	onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
	displayName: string;
	showArrow?: boolean;
}

const delimiter = '.';

export const SonarRecordParent: React.FC<SonarRecordParentProps> = ({ displayName, onClick, showArrow }) =>
	<When condition={ displayName }>
		<span
			className='record-parent-prefix'
			onClick={ onClick }>
			<When condition={ showArrow }>
				<ArrowLeftOutlined />
			</When>
			{ displayName }
		</span>
		{ delimiter }
	</When>;

